import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-adoption-date-amendment-date",
  // imports: [],
  templateUrl: "./adoption-date-amendment-date.component.html",
  styleUrl: "./adoption-date-amendment-date.component.css",
  standalone: false,
})
export class AdoptionDateAmendmentDateComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
